import { Model } from "flexlayout-react";
import { Dummy } from "../../breakageandreturn/charts/Dummy";
import { Header } from "../../../components/Header";
import { BreakageAndReturnTableView } from "../tableview/BreakageAndReturnTableView";
import { FilterTitle, NoTitle } from "../../vectorset2/layout/VectorSet2Titles";

import { FilterList } from "../filterlist/FilterList";

export const factory = (node, filter) => {
  const getPctile = () => {
    const p = filter[" Pctile "].filter((item) => item !== "All");
    if (p.length === 2) {
      return "95th & 99th";
    } else if (p.length === 1) {
      return (+p[0]).toFixed(0) + "th";
    } else return "_";
  };

  var component = node.getComponent();
  switch (component) {
    case "BreakageAndReturnTableView":
      return <BreakageAndReturnTableView />;
    case "Header":
      return (
        <Header
          title="Please explore the historic breakage of the Vector Model and Sigma VaR and OaR estimates and the returns experienced by a VaR or OaR constrained investor would experience using the Vector Model relative to those they would experience using Sigma, which is assumed to earn the underlying return of the asset, subject to a cap and floor of 3x and 0.333x. Past performance is no guarantee of future results.  See Terms and Conditions and our blog for important additional disclosures."
          label="breakageandreturn"
        >
          <div>
            VaR and OaR Breakage and Return on Capital for {getPctile()} %tile
            and {(+filter.Horizon[0]).toFixed(0)}d horizon
          </div>
        </Header>
      );
    //VaR and OaR breakage and Return on VaR and OaR based Capital
    case "ModelDate":
      return <FilterList field={"ModelDate"} search={false} />;
    case "RiskModel":
      return <FilterList field={"RiskModel"} search={false} />;
    case "Ticker":
      return <FilterList field={"Ticker"} search={false} />;
    case " Pctile ":
      return <FilterList field={" Pctile "} search={false} />;
    case "Horizon":
      return <FilterList field={"Horizon"} search={false} radio={true} />;
    default:
      return <Dummy />;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};
const getParentTabsets = (model) => {
  const tree = {};
  const walk = (obj) => {
    if (obj.children) {
      const parent = obj.id;
      tree[parent] = [];
      obj.children.forEach((item) => {
        tree[parent].push(item.id);
        walk(item);
      });
    }
  };
  walk(model.layout);
  const parents = {};
  Object.entries(tree).forEach((item) => {
    item[1].forEach((child) => {
      parents[child] = item[0];
    });
  });
  return parents;
};

const modifyModel = (model, layoutState, setLayoutState) => {
  if (layoutState.actionRef.current !== undefined) {
    let tabsetId = "";
    if (layoutState.actionRef.current.isTab) {
      const parent = getParentTabsets(model);
      tabsetId = parent[layoutState.actionRef.current.tabid];
    } else {
      tabsetId = layoutState.actionRef.current.tabid;
    }
    let update = (obj) => {
      if (obj.id === tabsetId) {
        //update
        Object.entries(layoutState.actionRef.current.attributes).forEach(
          (item) => {
            obj[item[0]] = item[1];
          }
        );
      } else if (obj.children) {
        obj.children.forEach((item) => update(item));
      }
    };
    update(model.layout);

    const newState = {
      ...layoutState,
      model: Model.fromJson(model),
    };

    setLayoutState(newState);
    return model;
  } else {
    return model;
  }
};

export const onAction = (action, layoutState) => {
  const nodeID = action.data.fromNode;
  if (nodeID) {
    layoutState.actions.prepareAction(nodeID);
  }
  return action;
};

export const layoutModelChange = (
  model,
  layoutState,
  setLayoutState,
  grefs
) => {
  // console.log(JSON.stringify(model.toJson()));
  grefs.layout.current = JSON.stringify(
    modifyModel(model.toJson(), layoutState, setLayoutState)
  );
};
export const onRenderTab = (node, renderState, componentSize) => {
  var component = node.getComponent();
  switch (component) {
    case "ModelDate":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Model Date"}
          name={component}
        />
      );
      break;
    case "Horizon":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Horizon"}
          name={component}
        />
      );
      break;
    case "RiskModel":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Risk Model"}
          name={component}
        />
      );
      break;
    case " Pctile ":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Pctile"}
          name={component}
        />
      );
      break;
    case "Ticker":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Ticker"}
          name={component}
        />
      );
      break;
    case "Dummy":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Dummy"} />
      );
      break;
    case "Header":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Header"} />
      );
      break;

    default:
    //do nothing
  }
};
